import  { ReactNode } from 'react'

interface HeroSectionProps {
   title: string,
   description?: string, 
   more?: ReactNode
}

export default function HeroSection({ title , description , more }: HeroSectionProps) {
    return (
        <div className="relative overflow-hidden bg-gradient-to-br from-orange-700 via-orange-500 to-amber-400">

            {/* Cercles décoratifs */}
            <div className="absolute -top-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-2xl pointer-events-none" />
            <div className="absolute -bottom-16 -left-16 w-72 h-72 bg-orange-900/20 rounded-full blur-2xl pointer-events-none" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full pointer-events-none" />

            <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-28 md:pt-20 md:pb-36">
                <div className="max-w-2xl">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-[1.1] tracking-tight mb-5">
                        {title}
                    </h1>

                    {description && (
                        <p className="text-orange-100/90 text-base md:text-lg leading-relaxed mb-10 max-w-xl">
                            {description}
                        </p>
                    )}

                    {/* Badges de réassurance */}
                    {more}
                </div>
            </div>

            {/* Vague de transition (Modifiée ici avec -bottom-[1px]) */}
            <div className="absolute -bottom-[1px] left-0 right-0 leading-none select-none pointer-events-none">
                <svg
                    viewBox="0 0 1440 80"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full block"
                    preserveAspectRatio="none"
                >
                    <path
                        fill="#f9fafb" // Assure-toi que cette couleur correspond EXACTEMENT au fond de la section suivante
                        d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z"
                    />
                </svg>
            </div>
        </div>
    )
}